// EPI Client 端 Service Request 子表自定义行为
// 当前仅一个 topButton: batchDownloadServiceRequestDocuments
// 触发时读取 sectionComponent 的 selectedRowKeys（DefaultTable 在 rowSelection.onChange 里维护）
// POST 给 ClientPortalAPI /Business/ServiceRequest/BatchDownloadDocuments 拿到 zip
import { message } from 'antd';
import { httpClient } from 'util/Api';
import * as globalFunction from 'util/GlobalFunction';

export function batchDownloadServiceRequestDocuments({ sectionComponent } = {}) {
  // sectionComponent 是 DefaultSection；真正的 Table 实例在 child.current
  const table = sectionComponent?.child?.current;
  const selectedKeys = table?.state?.selectedRowKeys || [];
  if (selectedKeys.length === 0) {
    message.warning('Please select at least one request.');
    return;
  }
  // download() 支持 method=post + json body + 触发浏览器下载 zip
  globalFunction.download({
    method: 'post',
    url: '/Business/ServiceRequest/BatchDownloadDocuments',
    data: selectedKeys,
    filename: 'service-request-documents.zip',
    errorMessageText: 'Batch download failed.',
  });
}
